import React from 'react'
import { Trans } from 'react-i18next'

import { useHandler } from '@surglogs-app/hooks'
import { TextButton } from '@surglogs-app/ui'
import { useToast } from '@surglogs-app/ui.toast'

import { useTranslation } from '../services'

export const useUnsupportedFileToast = (
  opts?: Parameters<typeof useToast>[0],
) => {
  const { t } = useTranslation()
  const { showErrorToast } = useToast(opts)

  const showUnsupportedFileToast = useHandler(
    ({ onSupportedFilesClick }: { onSupportedFilesClick: () => void }) => {
      showErrorToast({
        title: t('unsupportedFile.title'),
        text: (
          <Trans
            {...{
              t,
              i18nKey: 'unsupportedFile.text',
              components: {
                anchor: (
                  <TextButton
                    {...{
                      onClick: onSupportedFilesClick,
                      lh: 'inherit',
                      fz: 'inherit',
                    }}
                  />
                ),
              },
            }}
          />
        ),
      })
    },
  )

  return { showUnsupportedFileToast }
}
